import * as React from 'react';

import * as styles from './Link.css';
import { useDeviceType } from '@cian/ui-kit';

interface ILinkProps {
  children: React.ReactNode;
  href: string;
}

export const Link: React.FC<ILinkProps> = ({ children, href }) => {
  const device = useDeviceType();

  const target = device === 'desktop' ? '_blank' : undefined;

  return (
    <a href={href} className={styles['link']} target={target} rel="nofollow noopener noreferrer">
      {children}
    </a>
  );
};
